
import React, { Fragment, useEffect, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";


interface TipProps extends React.PropsWithChildren {
  label: string | React.JSX.Element;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  align?: "start" | "end" | "center";
  truncate?: boolean;
  className?: string;
  contentClassName?: string;
  multiple?: boolean;
  asChild?: boolean;
}

export const Tip = ({
  label,
  children,
  side = 'top',
  sideOffset = 4,
  align = 'center',
  truncate = true,
  className = '',
  contentClassName = '',
  multiple = false,
  asChild,
}: TipProps) => {
  if (!label) {
    return <>{children}</>;
  }
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger
          asChild={asChild || !!children}
          className={cn(
            !!children && truncate && "truncate",
            className,
          )}
        >
          {children || label}
        </TooltipTrigger>
        <TooltipContent
          side={side}
          sideOffset={sideOffset}
          className={cn(
            "bg-foreground",
            multiple && "rounded-2xl py-4 px-5",
            contentClassName,
          )}
          align={align}
        >
          {
            typeof label === 'string' ? (
              <>
                {
                  label.split('\n').map((str, index) => {
                    return (
                      <Fragment key={index}>
                        {
                          index > 0 ? <br /> : null
                        }
                        {str}
                      </Fragment>
                    )
                  })
                }
              </>
            ) : label
          }
        </TooltipContent>
      </Tooltip>
    </TooltipProvider >
  )
};